/**
 * Finds duplicate elements in an array based on a specified key
 * @param {Array} arr - Array of objects to check for duplicates
 * @param {string} key - The property key to compare for duplicates
 * @returns {Array} Array of duplicate objects (only second and further occurrences, not the first)
 */
export const getDuplicates = (arr, key) => {
    if (!arr || !Array.isArray(arr)) {
        return [];
    }

    const seen = new Set();
    const duplicates = [];

    arr.forEach((obj) => {
        const keyValue = obj[key];
        if (seen.has(keyValue)) {
            duplicates.push(obj);
        } else {
            seen.add(keyValue);
        }
    });

    return duplicates;
};

/**
 * Finds duplicate elements in an array of primitives
 * @param {Array} arr - Array of primitive values
 * @returns {Array} Array of duplicate values
 */
export const getDuplicatesPrimitive = (arr) => {
    if (!arr || !Array.isArray(arr)) {
        return [];
    }

    const seen = new Map();
    const duplicates = [];

    arr.forEach((item) => {
        if (seen.has(item)) {
            if (seen.get(item) === 1) {
                duplicates.push(item);
            }
            seen.set(item, seen.get(item) + 1);
        } else {
            seen.set(item, 1);
        }
    });

    return duplicates;
};

/**
 * Gets duplicate groups - returns an object where keys are the duplicate values
 * and values are arrays of all objects that have that duplicate value
 * @param {Array} arr - Array of objects to group duplicates
 * @param {string} key - The property key to group by
 * @returns {Object} Object with duplicate groups
 */
export const getDuplicateGroups = (arr, key) => {
    if (!arr || !Array.isArray(arr)) {
        return {};
    }

    const groups = new Map();

    arr.forEach((obj) => {
        const keyValue = obj[key];

        if (!groups.has(keyValue)) {
            groups.set(keyValue, []);
        }
        groups.get(keyValue)
            .push(obj);
    });

    // Filter out groups with only one item (not duplicates)
    const duplicateGroups = {};
    groups.forEach((group, keyValue) => {
        if (group.length > 1) {
            duplicateGroups[keyValue] = group;
        }
    });

    return duplicateGroups;
};
